import { IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ORMMediator } from 'utility-ts-orm';
import { ApStudentDetailsModel } from '../../global/components/student_details/models/ap_student_details_model';
import { APUserModeConfig } from '../../global/components/user_mode_config/config/ap_user_mode_config';
import { APModel } from '../../global/models/ap_model';
import {
  SlotStatusCssClassColorMap,
  SlotStatusTextMap,
  SlotStatusTextToColorMap
} from '../../plan/components/slot_status_badge/servants/slot_status_badge_html_servant';
import { APAlternatePlanDetailsSlot } from '../builders/ap_alternate_plan_details_slot_builder';
import { APAlternatePlanListItem } from '../builders/ap_alternate_plan_list_item_builder';
import { APAlternatePlanNonExistingCourse } from '../builders/ap_alternate_plan_non_existing_course_builder';
import { IAPAlternatePlanListDatasource } from '../datasources/alternate_plan_list_datasource';
import { IAPAlternatePlanNonExistingCoursesDatasource } from '../datasources/non_existing_courses_new_plan_datasource';
import {
  AlternatePlanComparePlansModel,
  IAlternatePlanComparePlanEntry
} from '../models/alternate_plan_compare_plans_model';

interface INonExistingCourse {
  title: APAlternatePlanNonExistingCourse['title'];
  bagde?: {
    cssClass: string;
    text: string;
  };
}
interface IAlternatePlanChangePlanPopupDetails {
  title: string;
  description: string;
  creditsText: string;
  nonExistingCourses: INonExistingCourse[];
  showAdvisorMeetingText: boolean;
}

export class AlternatePlanChangePlanPopupDetailsQuery implements IQuery {
  private _result: IAlternatePlanChangePlanPopupDetails = {
    title: '',
    description: '',
    creditsText: '',
    nonExistingCourses: [],
    showAdvisorMeetingText: false
  };

  constructor(
    private ngAlternatePlanComparePlansModel: AlternatePlanComparePlansModel,
    private ngAPAlternatePlanListDatasource: IAPAlternatePlanListDatasource,
    private ngApStudentDetailsModel: ApStudentDetailsModel,
    private ngAPUserModeConfig: APUserModeConfig,
    private ngAPAlternatePlanNonExistingCoursesDatasource: IAPAlternatePlanNonExistingCoursesDatasource,
    private ngAPModel: APModel
  ) {
    ORMMediator.registerQuery(
      this,
      ngAPModel,
      ngAPAlternatePlanNonExistingCoursesDatasource,
      ngAlternatePlanComparePlansModel,
      ngAPAlternatePlanListDatasource
    );
  }

  run() {
    const toPlanInfo = this.ngAlternatePlanComparePlansModel.read().to as IAlternatePlanComparePlanEntry;

    // will return default values if we don't have to plan selected
    if (_4.isUndefined(toPlanInfo)) {
      return this;
    }

    const currentPlan = this.ngAPAlternatePlanListDatasource.get(
      this.ngAPModel.currentProgram().id
    ) as APAlternatePlanListItem;
    const toPlan = this.ngAPAlternatePlanListDatasource.get(toPlanInfo.id) as APAlternatePlanListItem;
    this._result.showAdvisorMeetingText = true;
    let planApplyingUserLabel = 'your';
    if (this.ngAPUserModeConfig.isAdvisor()) {
      this._result.showAdvisorMeetingText = false;
      planApplyingUserLabel = `${this.ngApStudentDetailsModel.read().first_name}'s`;
    }
    this._result.title = `Change ${_4.upperFirst(planApplyingUserLabel)} Academic Plan`;
    this._result.description = `You are about to change ${planApplyingUserLabel} specialty of <span class="text-bold">${
      this.ngAPModel.currentProgram().name
    }</span> from the <span class="text-bold">${currentPlan.name}</span> to <span class="text-bold">${
      toPlan.name
    }</span>`;

    const toPlanRemainingCredits = toPlan.max_credits - toPlan.taken_credits;
    const currentPlanRemainingCredits = currentPlan.max_credits - currentPlan.taken_credits;
    this._result.creditsText = '';
    // we don't display creditText if both are same
    if (_4.gt(toPlanRemainingCredits, currentPlanRemainingCredits)) {
      this._result.creditsText = `This new plan has ${
        toPlanRemainingCredits - currentPlanRemainingCredits
      } more credits remaining than the current plan`;
    } else if (_4.gt(currentPlanRemainingCredits, toPlanRemainingCredits)) {
      this._result.creditsText = `This plan has ${
        currentPlanRemainingCredits - toPlanRemainingCredits
      } fewer credits than the current plan`;
    }

    const nonExistingCoursesInNewPlan = _4.sortBy(this.ngAPAlternatePlanNonExistingCoursesDatasource.read(), 'slot');
    this._result.nonExistingCourses = _4.map(nonExistingCoursesInNewPlan, (course) => ({
      title: `${course.cd} ${course.title}`,
      badge: !_4.isEmpty(course.status)
        ? {
            cssClass: SlotStatusCssClassColorMap[SlotStatusTextToColorMap[course.status]],
            text: SlotStatusTextMap[course.status]
          }
        : undefined
    }));
    return this;
  }

  get result() {
    return this._result;
  }
}

angular
  .module('capability-ng-academic-planner')
  .service('ngAlternatePlanChangePlanPopupDetailsQuery', AlternatePlanChangePlanPopupDetailsQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/alternate_plans/queries/alternate_plan_change_plan_popup_details_query.ts